import { useCreateTrialForOpenedExaminationMutation } from '@generated/graphql';
import { CircularLoading, useToast } from '@myhrbox/myhrbox-frontend-core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ROUTES from 'constants/routes';
import { EXAMINATION_IS_NOT_AVAILABLE_ERROR_MESSAGE } from 'constants/assessment';
import AssesmentAccessCard from 'components/AssesmentAccessCard';

const ExaminationReceive = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const { examinationId } = useParams<{ examinationId: string }>();
  const [receiveExamination] = useCreateTrialForOpenedExaminationMutation();
  const [showAssesmentAccessCard, setShowAssesmentAccessCard] = useState(false);

  const onError = () => {
    navigate(ROUTES.ASSESSMENT, { replace: true });
    showErrorToast(t('assessment.instruction.error.assessmentUnavailable'));
  };

  useEffect(() => {
    if (!examinationId) {
      onError();
    } else {
      receiveExamination({
        variables: {
          examinationId,
        },
      })
        .then((r) => {
          const trialId = r.data?.createTrialForOpenedExamination.id;
          if (trialId) {
            navigate(`${ROUTES.ASSESSMENT}/${trialId}`, { replace: true });
          } else {
            onError();
          }
        })
        .catch((err) => {
          const errorMessage = err?.cause?.extensions.originalError.error;

          if (errorMessage === EXAMINATION_IS_NOT_AVAILABLE_ERROR_MESSAGE) {
            setShowAssesmentAccessCard(true);
          } else {
            onError();
          }
        });
    }
  }, []);

  if (showAssesmentAccessCard) return <AssesmentAccessCard />;

  return <CircularLoading />;
};

export default ExaminationReceive;
